module.exports = __webpack_public_path__ + "static/media/custom-preview.131a4c51.png";